import request from '@/libs/request'
export async function findPage (params) {
  let data = await request.postJson('/order/healthCheckOrderInfo/findPage', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  }
  throw Error(data.message || '获取列表异常')
}

export async function receiveAction (params) {
  let data = await request.postJson('/order/healthCheckOrderInfo/receive', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  }
  throw Error(data.message || '领取异常')
}

export async function giveUpAction (params) {
  let data = await request.post('/order/healthCheckOrderInfo/giveup', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  }
  throw Error(data.message || '放弃异常')
}

export async function saveAction(params) {
  let data = await request.postJson('/order/healthCheckOrderInfo/save', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  }
  throw Error(data.message || '保存异常')
}

export async function confirmPositive (params) {
  let data = await request.post('/confirm/positive', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data
  }
  throw Error(data.message || '操作异常')
}

export async function uploadMarkFile (params) {
  let data = await request.postFile('/order/healthCheckOrderInfo/uploadMarkFile', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return true
  }
  throw Error(data.message || '上传标注数据异常')
}

export async function uploadFile (params) {
  let data = await request.postFile('/order/healthCheckOrderInfo/uploadFile', params, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  }
  throw Error(data.message || '上传标注数据异常')
}

export async function getWeasisUrlByFilmNo (params) {
  const url = `/order/healthCheckOrderInfo/getWeasisUrlByFilmNo?filmNo=${params.filmNo}`
  let data = await request.post(url, null, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  }
  throw Error(data.message || '获取标注数据异常')
}


export async function getHospitalList () {
  let data = await request.get(`/order/healthCheckOrderInfo/getHospitalList`, {}, false)
  if (data && data.code && data.code.toString() === '200') {
    return data.result
  }
  throw Error(data.message || '获取标注数据异常')
}